import React from "react";

export const AmbientBackground = () => (
  <div className="op-ambient" data-testid="ambient-bg" aria-hidden="true">
    <div className="op-ambient__glow-a" />
    <div className="op-ambient__glow-b" />
    <div className="op-grid-bg" />
    <div className="op-scanlines" />
  </div>
);

export default AmbientBackground;
